import InfoBar from "../infoBar.component";
import SelectedInfoTag from "../infoTags/selected.infoTag.infoBar.component";
import CountInfoTag from "../infoTags/count.infoTag.infoBar.component";

const OpenPartOrdersInfoBar = ({ totalCount = 0 }) => {
  return (
    <InfoBar>
      <CountInfoTag>Count: {totalCount || 0}</CountInfoTag>
      <SelectedInfoTag />
    </InfoBar>
  );
};

export default OpenPartOrdersInfoBar;
